const parent = [
    {
        path: '/',
        name: '/home',
        component: () => import('@/views/HomePage.vue'),
        meta: {requiresAuth: false, layout: 'Main', title: 'Home'},
    },
    {
        path: '/',
        component: () => import('@/views/ParentShell.vue'),
        meta: {requiresAuth: false, layout: 'Main', title: 'Home'},
        children: [
            {
                path: 'explore',
                name: '/explore',
                component: () => import('@/views/ExplorePage.vue'),
                meta: {requiresAuth: false, layout: 'Main', title: 'Explore'},
            },
            {
                path: 'profile/details/account',
                name: '/profile/details/account',
                component: () => import('@/views/profile/AccountPage.vue'),
                meta: {
                    requiresAuth: true,
                    layout: 'Main',
                    title: 'Profile | Account',
                },
            },
            {
                path: 'profile/orders',
                name: '/profile/orders',
                component: () => import('@/views/profile/OrdersPage.vue'),
                props: (route) => ({
                    params: {
                        page: parseInt(route.query.page) || 1,
                        status: route.query.status || 'CREATED,CONFIRMED,AWAITING_PAYMENT',
                    },
                }),
                meta: {
                    requiresAuth: true,
                    layout: 'Main',
                    title: 'Profile | Orders',
                },
            },
            {
                path: 'profile/orders/:orderNum',
                name: '/profile/orders/orderNum',
                component: () => import('@/views/profile/OrderPage.vue'),
                meta: {
                    requiresAuth: true,
                    layout: 'Main',
                    title: 'Profile | Order',
                },
            },
        ],
    },
]

export {parent}
